import {Button, Grid, TextField} from "@mui/material";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../../../utils/FirebaseAuthContext";

const SignInForm = () => {
    const [formState, setFormState] = useState({
        email: "",
        password: "",
        error: false
    });
    const auth = useAuth();
    const navigate = useNavigate();

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        setFormState({
            ...formState,
            [name]: value,
            error: false
        });
    }

    const signIn = () => {
        if (formState.email.length === 0 || formState.password.length === 0) {
            return;
        }

        auth.signIn(formState.email, formState.password)
            .then(() => {
                navigate("/dashboard");
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log(errorCode, errorMessage);
                setFormState({
                    ...formState,
                    error: true
                });
            });
    }

    return (
        <form onSubmit={(e) => {
            e.preventDefault();
            signIn();
        }}>
            <Grid container direction="column" alignItems="center" justifyContent="center" spacing={2}>
                <Grid item>
                    <TextField id="email" label="Emailová adresa" name="email" value={formState.email}
                               onChange={handleInputChange} variant="outlined" required type="email"/>
                </Grid>
                <Grid item>
                    <TextField id="password" label="Heslo" name="password" value={formState.password}
                               onChange={handleInputChange} variant="outlined" required type="password"
                               helperText={formState.error ? "Prihlásenie nebolo úspešné" : ""} error={formState.error}/>
                </Grid>
                <Grid item>
                    <Button type="submit" variant="contained">Prihlásiť sa</Button>
                </Grid>
            </Grid>
        </form>
    );
}

export default SignInForm;